import { useDispatch, useSelector } from "react-redux";
import AddTask from "./AddTask";
import "./ToDo.css";
import { TasksDispatch, TasksState } from "../../Redux/OrdersContext";
import { updateTask } from "../../Redux/slicers/tasksSlicer";
import TaskModel from "../../Models/TaskModel";
import { FiCheck } from "react-icons/fi";

function ToDo(): JSX.Element {
    const tasks = useSelector((state: TasksState) => state.tasks.value);
    const dispatch: TasksDispatch = useDispatch();

    async function markAsDone(task: TaskModel) {
        const updatedTask = { ...task, is_done: true };
        try {
            dispatch(updateTask(updatedTask));
        } catch (err) {
            alert("Failed to mark task as done: " + err);
        }
    }

    return (
        <div className="ToDo">
            <AddTask />
            {tasks.length > 0 && (
                <section className="todo-list" dir="rtl" aria-labelledby="todo-list-title">
                    <header className="todo-list__header">
                        <h2 id="todo-list-title">משימות פתוחות</h2>
                        <span>{tasks.length} משימות</span>
                    </header>
                    <div className="tasks">
                        {tasks.map((task, index) => (
                            <article className="todo-task" key={task.id}>
                                <div className="todo-task__number" aria-hidden="true">{index + 1}</div>
                                <p>{task.description}</p>
                                <button onClick={() => markAsDone(task)}>
                                    <FiCheck aria-hidden="true" />
                                    <span>סימון כבוצע</span>
                                </button>
                            </article>
                        ))}
                    </div>
                </section>
            )}
        </div>
    );
}

export default ToDo;
